import { hoc } from 'Lib';

const { ConditionalWrapper, ShowOnHoverWrapper, withFocus, withRouter } = hoc;

export { ConditionalWrapper, ShowOnHoverWrapper, withFocus, withRouter };
